import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { MemberQuotePage } from "@/features/my/quotes";
import { maskSearchFragment } from "@/features/shared/route-masking";

/**
 * The homeowner's quote page (R-1.4). A SIBLING of `my.orders.$orderId.tsx`,
 * not a child: the order detail renders no `<Outlet />`, so a nested route
 * would never draw.
 *
 * `option` is the option on show when the quote offers several (05 H-4). It
 * stays a lenient string: an id the quote no longer offers falls back to the
 * page's own default instead of crashing the route.
 */
const searchSchema = z.object({
  option: z.string().optional().catch(undefined),
  ...maskSearchFragment,
});

export const Route = createFileRoute(
  "/(member)/(protected)/my/quotes/$quoteId",
)({
  validateSearch: searchSchema,
  component: MemberQuotePage,
  head: () => ({
    meta: [
      { title: "Birdwatch - Quote" },
      { name: "description", content: "Birdwatch - Quote" },
    ],
  }),
});
